import { render, staticRenderFns } from "./SyncPrestaNode.vue?vue&type=template&id=037078f6&"
import script from "./SyncPrestaNode.vue?vue&type=script&lang=js&"
export * from "./SyncPrestaNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports